import { isAndroid, isNativeApp, runNative } from './platform';

/**
 * Publish safe-area insets as CSS variables so layout can respect notches and
 * system bars. On the web these resolve to 0px, so nothing shifts.
 */
export const applySafeAreaVariables = (): void => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  root.style.setProperty('--safe-area-top', 'env(safe-area-inset-top, 0px)');
  root.style.setProperty('--safe-area-right', 'env(safe-area-inset-right, 0px)');
  root.style.setProperty('--safe-area-bottom', 'env(safe-area-inset-bottom, 0px)');
  root.style.setProperty('--safe-area-left', 'env(safe-area-inset-left, 0px)');
  if (isNativeApp()) root.classList.add('is-native-app');
};

/** Status bar styling + splash screen dismissal. Native only. */
const initStatusBarAndSplash = async (): Promise<void> => {
  await runNative(async () => {
    const [{ StatusBar, Style }, { SplashScreen }] = await Promise.all([
      import('@capacitor/status-bar'),
      import('@capacitor/splash-screen'),
    ]);

    await StatusBar.setStyle({ style: Style.Light });
    if (isAndroid()) {
      await StatusBar.setBackgroundColor({ color: '#0b2a5b' });
      await StatusBar.setOverlaysWebView({ overlay: false });
    }
    await SplashScreen.hide({ fadeOutDuration: 250 });
  });
};

/**
 * One-shot native bootstrap. Safe to call on web — it becomes a no-op after
 * writing the safe-area variables.
 */
export const initNativeShell = (): void => {
  applySafeAreaVariables();
  void initStatusBarAndSplash();
};
